// Global define
window.global ||= window;